<div style="padding-left: 25px; padding-right: 25px;">
    <h2> Upcoming Events </h2>

    <app-calendar-event-card
        *ngFor="let e of visible_events.slice(0, event_limit)"
        [editable]="true"
        [event]="e"
        (edit)="editEvent.emit(e)"

    >
    </app-calendar-event-card>

    <div *ngIf="visible_events.length - event_limit; let remaining">
        <mat-card *ngIf="remaining > 0" class="upcomingEventCard">
            <mat-card-header>
                <mat-card-subtitle>
                    ... and {{ remaining }} more event{{ (remaining > 1) ? 's' : '' }}
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-actions>
                <button mat-button (click)="showMore()"> Show more </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
